/* eslint-disable import/named */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import DokanIcons from "../../../components/icon/DokanIcons";
import { Select } from 'antd';
import SalesChart from './SalesChart';
import { salesReport, setSalesOverviewType } from '../../../redux/reports/reportsActions';
// import DokanItemDateFilter from '../../../components/filter/DokanItemDateFilter';
import { chartData, chartDataLastMonth, chartThisMonth } from '../../../api/fakeData';

const { Option } = Select;

const SalesReport = () => {
    // eslint-disable-next-line no-unused-vars
    const overView = useSelector((state) => state.reports.salesOverview);
    const { selectedValue, salesChartSummary } = useSelector((state) => state.reports);
    const dispatch = useDispatch();
    let data;
    const defaultData = {
        value: 'this_month',
        data: [],
    };

    useEffect(() => {
        dispatch(salesReport());
    }, [dispatch]);

    const handleChange = (value) => {
        switch (value) {
            case 'this_month':
                dispatch(salesReport());
                break;
            case 'last_month':
                data = chartDataLastMonth;
                break;
            case 'this_year':
                data = chartData;
                break;
            default:
                data = chartThisMonth;
                break;
        }
        console.log(value, data);
        dispatch(setSalesOverviewType({ value, data }));
    };
    useEffect(() => {}, [selectedValue]);
    useEffect(() => dispatch(setSalesOverviewType(defaultData)), []);
    return (
        <>
            <div className="grid rounded-md border border-primary bg-white py-8 px-8 min-w-full">
                <div>
                    <div className="grid grid-cols-2 md:grid-cols-3 justify-start items-center">
                        <div>
                            <h3 className="text-primary text-md font-bold">Sales Report</h3>
                        </div>
                        <div className="hidden md:flex">
                            <div className="flex text-xs flex-grow-6 justify-start">
                                <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                    <div className="pb-1 flex items-center">
                                        <div className="w-2 h-2 mr-2 bg-blue-dodger rounded-full" />
                                        <p className="text-blue ">Sales</p>
                                    </div>
                                    <p className="font-medium pl-4 text-darkGray">
                                        ${salesChartSummary.total_sales || '0'}
                                    </p>
                                </div>
                                <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                    <div className="pb-1 flex items-center">
                                        <div className="w-2 h-2 mr-2 bg-orange rounded-full" />
                                        <p className="text-orange ">Order</p>
                                    </div>
                                    <p className="font-medium pl-4 text-darkGray">
                                        {salesChartSummary.total_orders || '0'}
                                    </p>
                                </div>
                                <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                    <div className="pb-1 flex items-center">
                                        <div className="w-2 h-2 mr-2 bg-green rounded-full" />
                                        <p className="text-green ">Earning</p>
                                    </div>
                                    <p className="font-medium pl-4 text-darkGray">
                                        ${salesChartSummary.total_earnings || '0'}
                                    </p>
                                </div>
                                <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                    <div className="pb-1 flex items-center">
                                        <div className="w-2 h-2 mr-2 bg-button-tracking rounded-full" />
                                        <p className="text-green ">Items</p>
                                    </div>
                                    <p className="font-medium pl-4 text-darkGray">
                                        {salesChartSummary.total_items || '0'}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="flex flex-1 justify-end">
                                <Select
                                    defaultValue="this_month"
                                    style={{ width: 120 }}
                                    onChange={handleChange}
                                    value={selectedValue}
                                >
                                    <Option value="this_month">This Month</Option>
                                    <Option value="last_month">Last Month</Option>
                                    <Option value="this_year">This Year</Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>

                {/** mobile screen */}
                <div className="md:hidden">
                    <div className="grid grid-cols-2 gap-4 mt-35px">
                        <div>
                            <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                <div className="pb-1 flex items-center">
                                    <div className="w-2 h-2 mr-2 bg-blue-dodger rounded-full" />
                                    <p className="text-blue ">Sales</p>
                                </div>
                                <p className="font-medium pl-4 text-darkGray">
                                    ${overView?.total_sales || '0'}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                <div className="pb-1 flex items-center">
                                    <div className="w-2 h-2 mr-2 bg-orange rounded-full" />
                                    <p className="text-orange ">Order</p>
                                </div>
                                <p className="font-medium pl-4 text-darkGray">
                                    {overView?.total_orders || '0'}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                <div className="pb-1 flex items-center">
                                    <div className="w-2 h-2 mr-2 bg-green rounded-full" />
                                    <p className="text-green ">Earning</p>
                                </div>
                                <p className="font-medium pl-4 text-darkGray">
                                    ${overView?.total_sales || '0'}
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="mr-3 px-3 py-2 border border-primary rounded-md">
                                <div className="pb-1 flex items-center">
                                    <div className="w-2 h-2 mr-2 bg-button-tracking rounded-full" />
                                    <p className="text-green ">Items</p>
                                </div>
                                <p className="font-medium pl-4 text-darkGray">
                                    {overView?.total_items || '0'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="mt-50px grid min-w-full min-h-full">
                        <SalesChart selected={selectedValue} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default SalesReport;
